import ApiClient from "@/api/ApiClient";
import { HomeMultimediaAlbumListResponse } from "@API/src/component/memoruHome/album/types";
import {
  isTypeHomeMultimediaAlbumListResponse,
  isTypeHomeMultimediaAlbumResponse,
  isTypeHomeMultimediaResponse,
  isTypeHomeMultimediaListResponse,
} from "@/model/typeGuard/album";
import {
  FetchAlbumListRequest,
  FetchAlbumRequest,
  FetchMultimediaListRequest,
  FetchMultimediaRequest,
  FetchMultimediaPurchasedRequest,
} from "@/model/request/album";

export default class ApiAlbum {
  public static async fetchAlbumList(
    request: FetchAlbumListRequest
  ): Promise<HomeMultimediaAlbumListResponse> {
    const response = await ApiClient.get(`/album`, request);
    if (isTypeHomeMultimediaAlbumListResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async fetchAlbum(request: FetchAlbumRequest) {
    const response = await ApiClient.get(`/album/${request.albumId}`, request);
    if (isTypeHomeMultimediaAlbumResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async fetchMultimediaList(request: FetchMultimediaListRequest) {
    const response = await ApiClient.get(
      `/album/${request.albumId}/multimedia`,
      request
    );
    if (isTypeHomeMultimediaListResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async fetchMultimedia(request: FetchMultimediaRequest) {
    const response = await ApiClient.get(
      `/multimedia/${request.multimediaId}`,
      request
    );
    if (isTypeHomeMultimediaResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async fetchMultimediaPurchased(
    request: FetchMultimediaPurchasedRequest
  ) {
    const response = await ApiClient.get(`/multimedia/purchased`, request);
    if (isTypeHomeMultimediaListResponse(response)) {
      return response;
    }
    throw response;
  }
}
